import { Component, Input, Output, OnInit, AfterContentChecked, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router} from '@angular/router';
import { Location } from '@angular/common';
import { ContentService } from '../shared/content.service';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';
import { ConfigService } from '../shared/config.service';

import { prebootComplete } from "angular2-universal";

const type: string = 'writing';

@Component({
    template: require('./partials/content-writings.html')
})
export class ContentWritingsComponent implements OnInit, AfterContentChecked {
    
    public hasFilter: boolean = false;
    public currentLanguage: string;
    public contents: any;
    public currentPage: number = 1;
    public pageSize: number = 6; 
    public isFirstPage: boolean = false;
    @Output() onSearch: EventEmitter<Object> = new EventEmitter<Object>();

    constructor(public config: ConfigService, public intl: IntlService, private metaService: MetaService, private utils: UtilsService, private contentService: ContentService, private route: ActivatedRoute, private location: Location, private router: Router) {
    }

    ngOnInit(){
        
        this.route.parent.params.subscribe((params: Params) => {
            // Current language
            this.currentLanguage = params['lg'];
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        });

        this.route.params.subscribe((params: Params) => {
            // Meta (except language)
            let metaTitle = this.intl.data.COMMON.MENU.CATALOGUE[this.currentLanguage];
            this.metaService.setMeta(this.config.data.APP.FRONT.TITLE + ' | ' + this.intl.data.COMMON.MENU.WRITINGS.LONG[this.currentLanguage], '', '');
        });

        this.route.queryParams.subscribe(params => {
            // Has filters or not
            if(params['s']!=null || params['f']!=null)
                this.hasFilter = true;
            else 
                this.hasFilter = false;
            // Is first page
            if(params['from']!=null)
                this.isFirstPage = false;
            else {
                this.isFirstPage = true;
                this.currentPage = 1;    
            }
        });
    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }     
    }

    public onPageChange(event: any, target: string): void {
        this.currentPage = event.currentPage;
        let from = ( this.currentPage - 1 ) * this.pageSize;
        // Callback log
        this.onSearch.emit('page '+this.currentPage);
        // Nav
        let params = {};
        for(let qp in this.route.snapshot.queryParams){
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from; 
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    };

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-writings.component.ts